import PropTypes from 'prop-types'
import React from 'react'
import { components } from 'react-select'

import { TextLH } from 'styles/components/typography'

import './SingleValue.scss'

const SingleValue = ({ children, preValue, ...props }) => {
  let selectedValue = <span dangerouslySetInnerHTML={{ __html: children }} />

  if ('label_short' in props.data) {
    selectedValue = (
      <TextLH
        className="single-value__value"
        dangerouslySetInnerHTML={{ __html: props.data.label_short }}
      />
    )
  }

  return (
    <components.SingleValue {...props}>
      {preValue}
      {selectedValue}
    </components.SingleValue>
  )
}

SingleValue.propTypes = {
  children: PropTypes.node,
  preValue: PropTypes.node,
  data: PropTypes.object,
  selectProps: PropTypes.object,
}

SingleValue.defaultProps = {
  preValue: null,
}

export default SingleValue
